import createIcon from '../../createIcon';

/**
 * @component @name MobileFriendly
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguOTA0NyAxSDguOTA0NzNDNy44MDQ3MyAxIDYuOTA0NzMgMS45IDYuOTA0NzMgM1Y2SDguOTA0NzNWNEgxOC45MDQ3VjIwSDguOTA0NzNWMThINi45MDQ3M1YyMUM2LjkwNDczIDIyLjEgNy44MDQ3MyAyMyA4LjkwNDczIDIzSDE4LjkwNDdDMjAuMDA0NyAyMyAyMC45MDQ3IDIyLjEgMjAuOTA0NyAyMVYzQzIwLjkwNDcgMS45IDIwLjAwNDcgMSAxOC45MDQ3IDFaTTYuOTE0NzMgMTMuNDdMNC4zNjQ3MyAxMC45MkwzLjA5NDczIDEyLjE5TDYuOTA0NzMgMTZMMTQuMDk0NyA4LjgxTDEyLjgyNDcgNy41NEw2LjkxNDczIDEzLjQ3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MobileFriendly = createIcon('MobileFriendly', [
  [
    'path',
    {
      d: 'M18.9047 1H8.90473C7.80473 1 6.90473 1.9 6.90473 3V6H8.90473V4H18.9047V20H8.90473V18H6.90473V21C6.90473 22.1 7.80473 23 8.90473 23H18.9047C20.0047 23 20.9047 22.1 20.9047 21V3C20.9047 1.9 20.0047 1 18.9047 1ZM6.91473 13.47L4.36473 10.92L3.09473 12.19L6.90473 16L14.0947 8.81L12.8247 7.54L6.91473 13.47Z',
      key: '1byyfl',
    },
  ],
]);

export default MobileFriendly;
